module.exports = __webpack_public_path__ + "static/media/ic-list.dc45737b.svg";